<div class="row mt-5">
    <div class="col-12" style="padding-right: 0 !important; margin-right: 0 !important">
      <div class="card">
        <div class="card-body">
          <ng-container *ngIf="!showJobDetails">
            <ng-container *ngIf="displayLoader">
              <div class="loader-container" style="width: 55%">
                <ng-container *ngFor="let i of [1,2,3,4,5,6,7]">
                  <li class="t_loader">
                    <div class="card__desc load" [id]="i % 2 === 0 ? '' : 'long'"></div>
                  </li>
                </ng-container>
              </div>
            </ng-container>
            <div class="table-responsive">
              <table *ngIf="jobDetails.length > 0; else noJobs" class="table mb-2">
                <thead>
                  <tr>
                    <th scope="col">Roles</th>
                    <th scope="col">Job Title</th>
                    <th scope="col">Company Name</th>
                    <th scope="col">Start Data</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let job of jobDetails; index as i">
                    <td>{{ job.numOpenings || "N/A" }}</td>
                    <td><a href="javascript:void(0)" (click)="onJobTitleClick(job)">{{ job.title || "N/A" }}</a></td>
                    <td>{{ job.clientCorporationName || "N/A" }}</td>
                    <td>{{ job.startDate | date: "dd-MM-yyy" }}</td>
                    <td>
                      <app-status-icons [statusValue]="job.fileStatus"></app-status-icons>
                    </td>
                  </tr>
                </tbody>
              </table>
              <ng-template #noJobs>
                <div *ngIf="!displayLoader">
                  <h5>No Jobs</h5>
                </div>
              </ng-template>
            </div>
          </ng-container>
          <ng-container *ngIf="showJobDetails && selectedJob">
            <div class="job-details-view">
              <div class="header-section">
                <div class="job-selection">
                  <label for="jobTitle" class="bold mr-3">Job Title: </label>
                  <select [(ngModel)]="selectedJobId" (change)="onJobSelectionChange()">
                    <option *ngFor="let job of jobDetails" [ngValue]="job.id">
                      {{ job.title }}
                    </option>
                  </select>
                  <app-status-icons [statusValue]="selectedJob.fileStatus" class="ml-3"></app-status-icons>
                </div>
                <button class="btn btn-primary bold" (click)="backToJobList()">Back</button>
              </div>
              <div class="custom-table details-table">
                <div class="table-row">
                  <div class="col label">Job Title</div>
                  <div class="col value">{{ selectedJob.title }}</div>
                </div>
                <div class="table-row">
                  <div class="col label">Company Name</div>
                  <div class="col value">{{ selectedJob.clientCorporationName }}</div>
                </div>
                <div class="table-row">
                  <div class="col label">Number of Openings</div>
                  <div class="col value">{{ selectedJob.numOpenings }}</div>
                </div>
                <div class="table-row">
                  <div class="col label">Address Line 1</div>
                  <div class="col value">{{ selectedJob.address_line1 || 'N/A' }}</div>
                </div>
                <div class="table-row">
                  <div class="col label">City</div>
                  <div class="col value">{{ selectedJob.address_city || 'N/A' }}</div>
                </div>
                <div class="table-row">
                  <div class="col label">State</div>
                  <div class="col value">{{ selectedJob.address_state }}</div>
                </div>
                <div class="table-row">
                  <div class="col label">Start Date</div>
                  <div class="col value">{{ selectedJob.startDate | date: "dd-MM-yyy" }}</div>
                </div>
                <div class="table-row">
                  <div class="col label">Status</div>
                  <div class="col value">{{ selectedJob.status }}</div>
                </div>
              </div>
              <hr class="section-divider">
              <div class="compliance-section">
                <ng-container *ngIf="isComplianceLoading">
                  <div class="loader-container" style="width: 55%">
                    <ng-container *ngFor="let i of [1,2,3,4]">
                      <li class="t_loader">
                        <div class="card__desc load" [id]="i % 2 === 0 ? '' : 'long'"></div>
                      </li>
                    </ng-container>
                  </div>
                </ng-container>
                <ng-container *ngIf="!isComplianceLoading">
                  <div class="custom-table compliance-table">
                    <div class="table-row" *ngFor="let fileType of mandatoryFileTypes">
                      <div class="col file-type">{{ fileType }}</div>
                      <div class="col file-name">{{ getFileNameForType(fileType) }}</div>
                      <div class="col file-status">
                        <app-status-icons [statusValue]="hasFileForType(fileType)"></app-status-icons>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>